import { findRelatedElementByElement } from "../DOMutils";
import animateValue, { updateHeight } from "../animateValue";

export default class Dropdown {
    constructor(el) {
        this.el = el;
        this.isOpened = false;
        this.currentValue = null;
        this.defaultValue = null;
        this.toggle = this.el.querySelector(".dropdown__toggle");
        this.toggleValue = this.el.querySelector(".dropdown__toggle-value");
        this.content = this.el.querySelector(".dropdown__content");
        this.handleOutsideClickBinded = this.handleOutsideClick.bind(this);
        this.externalEventListeners = {
            valueChange: [],
        };

        this.setDefaultValue();
    }

    toggleDropdown() {
        this.isOpened = !this.isOpened;
        this.el.classList.toggle("dropdown--active");
        animateValue(
            this.content,
            updateHeight,
            this.content.offsetHeight,
            !this.isOpened ? 0 : this.content.scrollHeight > 300 ? 300 : this.content.scrollHeight,
            150
        );
        this.setOutsideClickEventListener();
    }

    handleOutsideClick(e) {
        const isInside = findRelatedElementByElement(e.target, "parentElement", this.el);

        if (isInside) return;

        this.toggleDropdown();
    }

    setOutsideClickEventListener() {
        this.isOpened
            ? document.addEventListener("click", this.handleOutsideClickBinded, false)
            : document.removeEventListener("click", this.handleOutsideClickBinded, false);
    }

    setValue(value, e) {
        if (value === this.currentValue) return;

        this.currentValue = value;
        this.toggleValue ? (this.toggleValue.innerText = value) : (this.toggle.innerText = value);
        this.runExternalEventHandlers("valueChange", e);
    }

    handleContentClick(e) {
        const value = e.target.dataset.value;

        if (!value) return;

        this.toggleDropdown();

        this.setValue(value, e);
    }

    setEventListeners() {
        this.toggle.addEventListener("click", this.toggleDropdown.bind(this));
        this.content.addEventListener("click", this.handleContentClick.bind(this));
    }

    on(event, handler) {
        if (this.externalEventListeners[event] && typeof handler === "function") {
            this.externalEventListeners[event].push(handler);
        }
    }

    runExternalEventHandlers(event, e) {
        if (this.externalEventListeners[event] && this.externalEventListeners[event].length !== 0)
            this.externalEventListeners[event].forEach((eventHandler) =>
                eventHandler.call(null, e.target, this, e)
            );
    }

    setDefaultValue() {
        const defaultItem = this.content.querySelector(".dropdown__item[data-default='true']");

        if (!defaultItem || !defaultItem.dataset.value) return;

        this.currentValue = defaultItem.dataset.value;
        this.defaultValue = defaultItem.dataset.value;
    }

    run() {
        if (!this.toggle || !this.content) return;

        this.setEventListeners();
    }
}
